// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"328":"e0ffb42f","442":"56ba19b7","567":"92466652","611":"453c822d","727":"6d5489fb","794":"81d5fc5c","894":"e8291c02","916":"695ffb7f","947":"17b71289"}[chunkId] + ".chunk.css";
};